export default function LoadingSkeleton({ rows = 3 }) {
  return <div className="grid gap-3">{Array.from({ length: rows }).map((_, i) => <div key={i} className="h-20 animate-pulse rounded-app bg-white/10" />)}</div>;
}
